import Accordion from "react-bootstrap/esm/Accordion";
import RootLayout from "../../components/layout/RootLayout";;
import User from "../../types/user";
import { customerFAQ, generalFAQ } from "./constant";
import { auditorFAQ } from "./constant";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { getUserRole } from "../../utils/authUtils";

import faqPageIcon from "../../assets/images/faq-page-icon.svg";
import "./FAQ.css";

const FAQ = () => {
  const user = useSelector((state: RootState) => state.users.loginUser);
  const userRoles = getUserRole(user as User);

  const faqs = [
    ...(userRoles.isAuditor ? auditorFAQ : []),
    ...(userRoles.isCustomer ? customerFAQ : []),
    ...generalFAQ,
  ];

  return (
    <RootLayout
      title="FAQs"
      subtitle="Frequently Asked Questions"
      logo={faqPageIcon}
      logoAlt="FAQ Page"
      showBackButton
    >
      <Accordion defaultActiveKey="0" bsPrefix="faq-accordion">
        {faqs.map((faq, index) => (
          <Accordion.Item key={index} eventKey={index.toString()} bsPrefix="faq-accordion-item">
            <Accordion.Header bsPrefix="faq-accordion-header">
              {faq.question}
            </Accordion.Header>
            <Accordion.Body bsPrefix="faq-accordion-body">
                <>
                  {faq.answer.split(/(https?:\/\/[^\s]+)/).map((part, i) => (
                    part.match(/^https?:\/\//) ? 
                      <a key={i} href={part} target="_blank" rel="noopener noreferrer">{part}</a> : 
                      part
                  ))}
                </>
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </RootLayout>
  );
}

export default FAQ;
